import React, { useState } from 'react';
import { IProps } from './types';

const SurveyPage: React.FC<IProps> = (props) => {
  const [fileSrc, setFillSrc] = useState('');
  const [imgBase64, setimgBase64] = useState('');

  // if (props.showImg) {
  //   setFillSrc("");
  //   setimgBase64("");
  // }

  const handleFile = async (event: any) => {
    const file = event.target.files[0];
    if (file === undefined) return;
    // console.log(file);
    setFillSrc(URL.createObjectURL(file));

    const img = await convertFile(file).then((val: any) => val) as string;

    setimgBase64(img);
  };

  function convertFile (file: any) {
    return new Promise((resolve, reject) => {
      // 建立FileReader物件
      const reader = new FileReader();
      // 註冊onload事件，取得result則resolve (會是一個Base64字串)
      reader.onload = () => { resolve(reader.result); };
      // 註冊onerror事件，若發生error則reject
      reader.onerror = () => { reject(reader.error); };
      // 讀取檔案
      reader.readAsDataURL(file);
    });
  }

  function handleUpload () {
    setFillSrc('');
    setimgBase64('');

    const file = document.getElementById('avatar') as HTMLInputElement;
    if (file) {
      file.value = '';
    }

    return imgBase64;
  }

  return (
    <div className="survey-page">
      <div className="survey-page__title">{props.content && props.content.title}</div>
      <div className="survey-page__desc">
        <p>{props.content && props.content.desc}</p>
      </div>
      <div className="survey-page__content">
        <div
          className="survey-page__camera-screen"
          style={{
            backgroundImage: `url(${fileSrc || props.demoImgUrl})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            backgroundPosition: 'center'
          }}
        />
        <p className="survey-page__remind">{props.remindText}</p>
      </div>
      <div className="survey-page__controls">
        <div className="survey-page__btn--take-photo">
          <label>
            {
              fileSrc ? (<span>我要重拍</span>) : (<span>點這裡拍照</span>)
            }
            <input type="file" accept="image/*" capture="environment" id="avatar" name="avatar" onChange={handleFile} />
          </label>
        </div>
        {
          fileSrc && (
            <button className="survey-page__btn--upload" onClick={() => props.onUpload(handleUpload())}>確定並上傳</button>
          )
        }
      </div>
    </div>
  );
};

export default SurveyPage;
